import { render, staticRenderFns } from "./individual_analysis_report.vue?vue&type=template&id=60d6bb77&scoped=true"
import script from "./individual_analysis_report.vue?vue&type=script&lang=js"
export * from "./individual_analysis_report.vue?vue&type=script&lang=js"
import style0 from "./individual_analysis_report.vue?vue&type=style&index=0&id=60d6bb77&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60d6bb77",
  null
  
)

export default component.exports